<template>
	<div>
	<!-- 	<a-popover :visible="visible_bold" trigger="click" placement="left" :destroyTooltipOnHide="true"
			@visibleChange="moreEvent()" :getPopupContainer="triggerNode => {return triggerNode.parentNode;}">
			<template slot="content">
				<div>
					<div class='warp-title'>詳 情</div>
					<div class='warp_body'>
						<a-row>
							<a-col class="gutter-row" :span="6">
								<div class="gutter-box">
									<img  :src="icon0" alt="">
									
								</div>
							</a-col>
							<a-col class="gutter-row" :span="18">
								<div class="gutter-box">
									{{record.username}}
								</div>
							</a-col>
						</a-row>
						<a-row>
							<a-col class="gutter-row" :span="6">
								<div class="gutter-box">
									<img :src="icon1" alt="">
								</div>
							</a-col>
							<a-col class="gutter-row" :span="18">
								<div class="gutter-box">
									{{record.email}}
								</div>
							</a-col>
						</a-row>
						<a-row>
							<a-col class="gutter-row" :span="6">
								<div class="gutter-box">
									<img :src="icon2" alt="">
								</div>
							</a-col>
							<a-col class="gutter-row" :span="18">
								<div class="gutter-box">
									{{record.mobile}}
								</div>
							</a-col>
						</a-row>
						<a-row>
							<a-col class="gutter-row" :span="6">
								<div class="gutter-box">
									<img :src="icon3" alt="">
								</div>
							</a-col>
							<a-col class="gutter-row" :span="18">
								<div class="gutter-box">
									{{record.birth}}
								</div>
							</a-col>
						</a-row>
						<a-row>
							<a-col class="gutter-row" :span="6">
								<div class="gutter-box">
									<img :src="icon4" alt="">
								</div>
							</a-col>
							<a-col class="gutter-row" :span="18">
								<div class="gutter-box">
									{{record.logintime}}
								</div>
							</a-col>
						</a-row>
						<br>
					</div>
				</div>
			</template> -->
			<img :src="visible_bold ? icon_pdf1 : icon_pdf" class="imageC" @click='moreEvent(0)'>
			<!-- <xiangqing v-if='visible_bold' :island='visible_bold' @child='moreEvent' :record='record'></xiangqing> -->
		<!-- </a-popover> -->
	</div>
</template>

<script>
	import App from '@/assets/app.js';
	import xiangqing from './xiangqing.vue';
	
	export default {
		props: ['record'],
		components:{
			xiangqing
		},
		data() {
			return {
				visible_bold: false,
				icon_pdf: require('@/image/icon_pdf.png'),
				icon_pdf1: require('@/image/icon_pdf1.png'),
				icon0: require('@/image/icon_yonghu.png'),
				icon1: require('@/image/icon_mes.png'),
				icon2: require('@/image/icon_shouji.png'),
				icon3: require('@/image/iocn_sr.png'),
				icon4: require('@/image/icon_sj.png'),
			}
		},
		methods: {
			moreEvent(val) {
				this.visible_bold = !this.visible_bold
				this.$emit('child',val)
			},
		}
	}
</script>

<style lang='scss' scoped>
	.warp_body {
		margin: 10px;
		width: 15rem;

		.ant-row {
			padding: 8px;
		}

		.gutter-box {
			height: 1.6rem;
			line-height: 1.6rem;
			font-size: .8rem;
			img{
				width: 1.2rem;
			}
		}
		.ant-col-6{
			.gutter-box{
				text-align: center;
			}
		}
	}

	.warp-title {
		background-color: #f1f1f1;
		height: 2.2rem;
		text-align: center;
		line-height: 2.2rem;
		font-size: .9rem;
		font-weight: 600;
		letter-spacing: 1rem !important;
	}
</style>
